import React from 'react';
import PropTypes from 'prop-types';

/* componentDidMount() {
    const script = document.createElement('script');

    script.id = 'clutch-widget-script';
    script.src = 'https://widget.clutch.co/static/js/widget.js';
    script.async = true;

    document.body.appendChild(script);
}
<div
    className="clutch-widget"
    data-url="https://widget.clutch.co"
    data-widget-type="4"
    data-expandifr="true"
    data-height="auto"
    data-snippets="true"
    data-clutchcompany-id="751898"
/> */

const AboutClutch = ({ t }) => (
    <div className="about-clutch">
        <div className="section-title">
            <h2>{ t('about.clutch.title') }</h2>
        </div>
        <div className="about-clutch-content">
            <a href="https://clutch.co/profile/lemlock#highlights" target="_blank" rel="noopener noreferrer">
                <picture>
                    <source srcSet={ require('../../../assets/images/clutch/clutch-mobile.png') } media="(max-width: 767px)"/>
                    <source srcSet={ require('../../../assets/images/clutch/clutch-tablet.png') } media="(min-width: 768px) and (max-width: 1023px)"/>
                    <source srcSet={ require('../../../assets/images/clutch/clutch-desktop.png') } media="(min-width: 1024px)"/>
                    <img src={ require('../../../assets/images/clutch/clutch-desktop.png') } alt="Clutch"/>
                </picture>
            </a>
        </div>
    </div>
);

AboutClutch.propTypes = {
    t: PropTypes.func.isRequired
};

export default AboutClutch;



// WEBPACK FOOTER //
// ./src/components/content/about/AboutClutch.jsx